export default __webpack_public_path__ + "static/media/IMG_015a.5b8c78c1.jpg";